import * as React from 'react'
import { Box, Container, TextField, Typography, Button, Divider, Grid2 } from '@mui/material'
import dayjs from 'dayjs'
import AutoComplete from '../../BuiltInComponent/AutoComplete'
import Navbar from '../setup/Navbar'
import { useLocation, useNavigate } from 'react-router-dom'
import '../../services/GlobalVariables'
import TableDataWithPagination from '../../BuiltInComponent/TableWithPagination'
import DateTimePicker from '../../BuiltInComponent/DateTimePicker'
import Footer from '../setup/Footer'
import CheckboxLabels from '../../BuiltInComponent/CheckBox'
import Loading from '../../BuiltInComponent/Loading'
import { useDispatch, useSelector } from 'react-redux'
import {
    addNewEmployee, getIndividualEomployees, updateEmployee, addEmpAllowances, getEmpWiseAllowances, getSingleEmpAllowances,
    editEmpAllowances,
    deleteEmpAllowances
} from '../../features/PayrollManagement/employeeSlice'
import { getDepartments } from '../../features/AdminManagement/departmentSlice'
import { getDesignations } from '../../features/AdminManagement/designationsSlice'
import { getUnits } from '../../features/AdminManagement/unitsSlice'
import { getShifts } from '../../features/AdminManagement/shiftsSlice'
import { getAllowances } from '../../features/AdminManagement/allowancesSlice'
import { useEffect } from 'react'
import '../../services/GlobalVariables'


export default function EmployeeRegistration() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()

    const { departments } = useSelector((state) => state.dept);
    const { units } = useSelector((state) => state.units);
    const { designations } = useSelector((state) => state.desig);
    const { shifts } = useSelector((state) => state.shifts);
    const { allowances } = useSelector((state) => state.allowances);
    const { isLoadingEmpAll } = useSelector((state) => state.emp);

    const [joinDate, setJoinDate] = React.useState(dayjs());
    const [dateOfBirth, setDateOfBirth] = React.useState(dayjs());
    const [allRows, setAllRows] = React.useState([])

    React.useEffect(() => {
        if (global.msgError !== '') {
            navigate('/EmpList')
        }
    }, [navigate])

    React.useEffect(() => {
        dispatch(getDepartments())
        dispatch(getUnits())
        dispatch(getDesignations())
        dispatch(getShifts())
        dispatch(getAllowances())
    }, [dispatch])

    const Certifications = [
        { id: 1, degree: 'Masters' },
        { id: 2, degree: 'Bachelors' },
        { id: 3, degree: 'Intermediate' },
        { id: 4, degree: 'Matric' },
        { id: 5, degree: 'Middle' },
    ]

    const tableColumns = [
        { fieldName: 'eduID', cName: 'Edu ID', textAlign: 'left', width: '10%', dType: 'string', status: 'en' },
        { fieldName: 'edudegree', cName: 'Degree', textAlign: 'left', width: '15%', dType: 'string', status: 'en' },
        { fieldName: 'empUni', cName: 'Institute', textAlign: 'left', width: '25%', dType: 'string', status: 'en' },
        { fieldName: 'eduYear', cName: 'Passing Year', textAlign: 'center', width: '10%', dType: 'string', status: 'en' },
        { fieldName: 'eduGrade', cName: 'Grade', textAlign: 'center', width: '10%', dType: 'string', status: 'en' },
        { fieldName: 'eduRollNo', cName: 'Roll No', textAlign: 'center', width: '10%', dType: 'string', status: 'en' },
        { fieldName: 'edit', cName: 'Edit', textAlign: 'center', width: '10%', status: 'en' },
        { fieldName: 'delete', cName: 'Delete', textAlign: 'center', width: '10%', status: 'en' },
        { fieldName: 'delete', cName: 'Delete', textAlign: 'center', width: '10%', status: 'dis' },
    ]

    const exptableColumns = [
        { fieldName: 'expID', cName: 'ID', textAlign: 'left', width: '10%', dType: 'string', status: 'en' },
        { fieldName: 'expComp', cName: 'Company', textAlign: 'left', width: '25%', dType: 'string', status: 'en' },
        { fieldName: 'expDesi', cName: 'Designation', textAlign: 'left', width: '20%', dType: 'string', status: 'en' },
        { fieldName: 'expFrom', cName: 'From', textAlign: 'center', width: '10%', dType: 'string', status: 'en' },
        { fieldName: 'expTo', cName: 'To', textAlign: 'center', width: '10%', dType: 'string', status: 'en' },
        { fieldName: 'expLastPay', cName: 'Last Salary', textAlign: 'center', width: '15%', dType: 'string', status: 'en' },
        { fieldName: 'edit', cName: 'Edit', textAlign: 'center', width: '5%', status: 'en' },
        { fieldName: 'delete', cName: 'Delete', textAlign: 'center', width: '5%', status: 'en' },
        { fieldName: 'delete', cName: 'Delete', textAlign: 'center', width: '5%', status: 'dis' },
    ]

    const allowancetableColumns = [
        { fieldName: 'empallowanceID', cName: 'ID', textAlign: 'left', width: '10%', dType: 'string', status: 'en' },
        { fieldName: 'allowanceDescription', cName: 'Allowance', textAlign: 'left', width: '25%', dType: 'string', status: 'en' },
        { fieldName: 'Amount', cName: 'Amount', textAlign: 'left', width: '20%', dType: 'number', status: 'en' },
        { fieldName: 'edit', cName: 'Edit', textAlign: 'center', width: '5%', status: 'en' },
        { fieldName: 'delete', cName: 'Delete', textAlign: 'center', width: '5%', status: 'en' },
        { fieldName: 'delete', cName: 'Delete', textAlign: 'center', width: '5%', status: 'dis' },
    ]

    const currentYear = new Date().getFullYear()
    const years = []
    for (let i = 2000; i <= currentYear; i++) years.push({ id: i, year: i })

    // ------------ FORM STATE (JS) ------------
    const [emp, setEmp] = React.useState({
        empID: '',
        joinDate: '',
        dateOfBirth: '',
        empName: '',
        empFName: '',
        empCNIC: '',
        empContact: '',
        empEmail: '',
        empEmergencyCP: '',
        empEmergencyCPC: '',
        empAddress: '',
        deptDesc: '',
        desigID: '',
        empSalary: '',
        overTime: false,
        empOTRate: '',
        empProbDays: '',
        empProbEnds: '',
        empSalaryAfterProb: 'Inc. 20%',
        empUserStatus: false,
        empUserName: '',
        empUserPassword: '',
        machineID: '',
        shiftID: '',
        unitID: '',
        fixedSalary: false
    })

    const [empImageFile, setEmpImageFile] = React.useState(null)
    const [empImagePreview, setEmpImagePreview] = React.useState('')
    const [imageDirty, setImageDirty] = React.useState(false)

    useEffect(() => {
        const passedEmpID = location.state?.empID || ''
        if (passedEmpID) {
            dispatch(getIndividualEomployees(passedEmpID)).then((res) => {
                setEmp(prev => ({
                    ...prev,
                    empID: res.payload[0].empID,
                    joinDate: res.payload[0].entDate,
                    dateOfBirth: res.payload[0].dob,
                    empName: res.payload[0].empName,
                    empFName: res.payload[0].empFName,
                    empCNIC: res.payload[0].empCNIC,
                    empContact: res.payload[0].empContact,
                    empEmail: res.payload[0].empEmail,
                    empEmergencyCP: res.payload[0].empEmergencyCP,
                    empEmergencyCPC: res.payload[0].empEmergencyCPC,
                    empAddress: res.payload[0].empAddress,
                    deptDesc: res.payload[0].deptID,
                    desigID: res.payload[0].desigID,
                    empSalary: res.payload[0].empSalary,
                    overTime: res.payload[0].empOT,
                    empOTRate: res.payload[0].empOTRate,
                    empProbDays: res.payload[0].empProbDays,
                    empProbEnds: res.payload[0].empProbEnds,
                    empSalaryAfterProb: res.payload[0].empSAP,
                    // empUserStatus: res.payload[0].empName,
                    // empUserName: res.payload[0].empName,
                    // empUserPassword: res.payload[0].empName,
                    machineID: res.payload[0].machineID,
                    shiftID: res.payload[0].empShift,
                    unitID: res.payload[0].unitID,
                }))
                setJoinDate(res.payload[0].entDate)
                if (res.payload[0].empImage) {
                    const imgUrl = `${global.SET_API_URL}/employeesImages/${res.payload[0].empImage}`;

                    setEmpImagePreview(imgUrl)
                    setEmpImageFile(null)
                    setImageDirty(false)

                } else {
                    setEmpImagePreview('')
                    setEmpImageFile(null)
                    setImageDirty(false)
                }
                dispatch(getEmpWiseAllowances({ empID: res.payload[0].empID })).then((res) => {
                    setAllRows(res.payload)
                })
            })
        }
    }, [dispatch, location.state?.empID])

    const [eduForm, setEduForm] = React.useState({
        degree: '',
        institute: '',
        year: '',
        grade: '',
        rollNo: '',
    })

    const [allowancesData, setAllowancesData] = React.useState({
        empallowanceID: '',
        allowanceID: '',
        Amount: '',
    })
    const [eduData, setEduData] = React.useState([])

    const [expForm, setExpForm] = React.useState({
        company: '',
        designation: '',
        from: '',
        to: '',
        lastPay: '',
    })

    const [expData, setExpData] = React.useState([])

    const onEditClick = (id) => {
        console.log('edit row id:', id)
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        setEmp(prev => ({ ...prev, [name]: value }))
    }

    const handleOTToggle = (checked) => {
        setEmp(prev => ({
            ...prev,
            overTime: checked,
            empOTRate: checked ? prev.empOTRate : '',
        }))
    }

    const handle_CreateUser_Toggle = (checked) => {
        setEmp(prev => ({
            ...prev,
            empUserStatus: checked,
        }))
    }

    const handle_CreateUser_Toggle_FixedSalary = (checked) => {
        setEmp(prev => ({
            ...prev,
            fixedSalary: checked,
        }))
    }

    const setProb = (probDays) => {
        const days = Number(probDays || 0)
        const today = new Date()
        const probDate = dayjs(today).add(days, 'day').format('YYYY-MM-DD')
        setEmp(prev => ({ ...prev, empProbDays: String(probDays), empProbEnds: probDate }))
    }

    React.useEffect(() => {
        const base = Number(emp.empSalary || 0)
        if (base > 0) {
            const after = Math.round(base * 1.2)
            setEmp(prev => ({ ...prev, empSalaryAfterProb: String(after) }))
        } else {
            setEmp(prev => ({ ...prev, empSalaryAfterProb: 'Inc. 20%' }))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [emp.empSalary])

    const handleDeptChange = (data) => {
        const keys = Object.keys(data)
        setEmp(prevData => ({
            ...prevData, [keys[0]]: data[keys]
        }))
        if (keys[0] === 'deptID') {
            setEmp(prev => ({ ...prev, deptDesc: data[keys] }))
        }
        if (keys[0] === 'unitID') {
            setEmp(prev => ({ ...prev, unitID: data[keys] }))
        }
        if (keys[0] === 'shiftID') {
            setEmp(prev => ({ ...prev, shift: data[keys] }))
        }
        if (keys[0] === 'allowanceID') {
            setAllowancesData(prev => ({ ...prev, allowanceID: data[keys] }))
        }
        if (keys[0] === 'desigID') {
            setEmp(prev => ({ ...prev, desigID: data[keys] }))
        }
    }

    const handleDegreeChange = (val) => {
        const v = typeof val === 'string' ? val : (val && val.degree) ? val.degree : ''
        setEduForm(prev => ({ ...prev, degree: v }))
    }

    const handleYearFromChange = (val) => {
        const v = typeof val === 'string' ? val : (val && val.year) ? val.year : ''
        setExpForm(prev => ({ ...prev, from: v }))
    }

    const handleYearToChange = (val) => {
        const v = typeof val === 'string' ? val : (val && val.year) ? val.year : ''
        setExpForm(prev => ({ ...prev, to: v }))
    }

    const onImagePick = (e) => {
        const file = e.target.files && e.target.files[0]
        if (!file) return
        if (!/image\/(png|jpe?g|webp)/i.test(file.type)) {
            alert('Please select PNG/JPG/WEBP image')
            return
        }
        if (file.size > 2 * 1024 * 1024) {
            alert('Image too large (max 2MB)')
            return
        }
        setEmpImageFile(file)
        const reader = new FileReader()
        reader.onload = () => setEmpImagePreview(String(reader.result))
        reader.readAsDataURL(file)
        setImageDirty(true)
    }

    const addEdu = () => {
        if (!eduForm.degree || !eduForm.institute || !eduForm.year) {
            alert('Please fill Degree, Institute, Year')
            return
        }
        const next = {
            eduID: eduData.length + 1,
            edudegree: eduForm.degree,
            empUni: eduForm.institute,
            eduYear: eduForm.year,
            eduGrade: eduForm.grade || '',
            eduRollNo: eduForm.rollNo || ''
        }
        setEduData(prev => [...prev, next])
        setEduForm({ degree: '', institute: '', year: '', grade: '', rollNo: '' })
    }

    const addExp = () => {
        if (!expForm.company || !expForm.designation || !expForm.from || !expForm.to) {
            alert('Please fill Company, Designation, From, To')
            return
        }
        const next = {
            expID: expData.length + 1,
            expComp: expForm.company,
            expDesi: expForm.designation,
            expFrom: expForm.from,
            expTo: expForm.to,
            expLastPay: expForm.lastPay || ''
        }
        setExpData(prev => [...prev, next])
        setExpForm({ company: '', designation: '', from: '', to: '', lastPay: '' })
    }

    const validate = () => {
        if (!emp.empName) return 'Employee Name is required'
        if (!emp.deptDesc) return 'Department is required'
        if (!emp.empSalary) return 'Salary is required'
        return null
    }

    const onSubmit = async () => {
        const err = validate()
        if (err) return alert(err)

        const payload = {
            personal: {
                empID: emp.empID,
                joinDate: joinDate ? dayjs(joinDate).format('YYYY-MM-DD') : null,
                dob: dateOfBirth ? dayjs(dateOfBirth).format('YYYY-MM-DD') : null,
                empName: emp.empName,
                empFName: emp.empFName,
                empCNIC: emp.empCNIC,
                empContact: emp.empContact,
                empEmail: emp.empEmail,
                empEmergencyCP: emp.empEmergencyCP,
                empEmergencyCPC: emp.empEmergencyCPC,
                empAddress: emp.empAddress,
                department: emp.deptDesc,
                desigID: emp.desigID,
                empUserStatus: emp.empUserStatus ? 1 : 0,
                empUserName: emp.empUserName,
                empUserPassword: emp.empUserPassword,
                machineID: emp.machineID,
                unitID: emp.unitID,
                shiftID: emp.shiftID,
                fixedSalary: emp.fixedSalary
            },
            salary: {
                base: Number(emp.empSalary || 0),
                overTime: !!emp.overTime,
                otRate: Number(emp.empOTRate || 0),
                probationDays: Number(emp.empProbDays || 0),
                probationEnds: emp.empProbEnds || null,
                afterProb: isNaN(Number(emp.empSalaryAfterProb)) ? null : Number(emp.empSalaryAfterProb)
            },
            education: eduData.map(e => ({
                degree: e.edudegree,
                institute: e.empUni,
                year: e.eduYear,
                grade: e.eduGrade,
                rollNo: e.eduRollNo
            })),
            experience: expData.map(x => ({
                company: x.expComp,
                designation: x.expDesi,
                from: x.expFrom,
                to: x.expTo,
                lastPay: x.expLastPay
            }))
        }

        try {

            const hasId = !!payload.personal.empID;

            if (hasId) {
                // UPDATE
                await dispatch(updateEmployee({
                    id: payload.personal.empID,
                    payload,
                    // sirf tab image bhejo jab user ne change ki ho
                    empImageFile: imageDirty ? empImageFile : null,
                })).then(() => {
                    navigate('/EmployeeList')
                })
            } else {
                // CREATE
                await dispatch(addNewEmployee({
                    payload,
                    // create me agar user ne image nahi di to null
                    empImageFile: empImageFile || null,
                })).then(() => {
                    navigate('/EmployeeList')
                });
            }

        } catch (e) {
            console.error(e)
            const msg = e && e.response && e.response.data && e.response.data.message
            alert(msg || 'Failed to save employee')
        }
    }

    const handleJoinDateChange = (newDate) => {
        console.log(newDate.$d)
        setJoinDate(newDate)
        setEmp(prev => ({ ...prev, joinDate: '' }))
    };

    const handleDateofBirthChange = (newDate) => {
        console.log(newDate.$d)
        setDateOfBirth(newDate)
        setEmp(prev => ({ ...prev, dateOfBirth: '' }))
    };

    const onAllowanceEditClick = async (id) => {
        dispatch(getSingleEmpAllowances(id)).then((res) => {
            setAllowancesData({
                empallowanceID: res.payload.empallowanceID,
                allowanceID: res.payload.allowanceID,
                Amount: res.payload.Amount,
            })
        })
    }

    const onAllowanceDeleteClick = async (id) => {
        dispatch(deleteEmpAllowances(id)).then(() => {
            dispatch(getEmpWiseAllowances({ empID: emp.empID }))
                .then((res) => {
                    setAllRows(res.payload)
                })
        })
    }

    const onSubmitAllowance = async () => {
        if (allowancesData.empallowanceID === '') {
            console.log('add mode')
            dispatch(addEmpAllowances({
                empID: emp.empID,
                allowanceID: allowancesData.allowanceID,
                allowanceAmount: allowancesData.Amount
            })).then(() => {
                dispatch(getEmpWiseAllowances({ empID: emp.empID }))
                    .then((res) => {
                        setAllRows(res.payload)
                    })
            })
        } else {
            console.log(allowancesData.empallowanceID)
            console.log('edit mode')
            dispatch(editEmpAllowances({
                empallowanceID: allowancesData.empallowanceID,
                allowanceID: allowancesData.allowanceID,
                allowanceAmount: allowancesData.Amount
            })).then(() => {
                dispatch(getEmpWiseAllowances({ empID: emp.empID }))
                    .then((res) => {
                        console.log(res.payload)
                        setAllRows(res.payload)
                    })
            })
        }
    }
    return (
        <>
            <Navbar />
            <Container>
                <Box sx={{ background: 'linear-gradient(90deg, rgba(16,191,248,1) 0%, rgba(12,150,180,1) 100%)', mb: 3, borderRadius: 2, color: 'white', textShadow: 'black 4px 4px 10px' }}>
                    <Typography sx={{ textAlign: 'center', fontSize: 30, fontWeight: 'bolder' }}>Employee Registration</Typography>
                </Box>

                <Grid2 container spacing={2}>
                    <Grid2 size={4}>
                        <Typography sx={{ background: 'grey', mb: 1, p: 1, borderRadius: 5, color: 'white', fontSize: 20, fontWeight: 'bolder', textAlign: 'center', textShadow: 'black 2px 2px 5px' }}>
                            Employee Personal Information
                        </Typography>
                        {[...Array(10)].map((_, i) => (
                            <Divider key={i} variant="left" sx={{ bgcolor: i % 2 ? '#ffffff' : '#3f9cff' }} />
                        ))}
                    </Grid2>
                    <Grid2 size={8}></Grid2>

                    {/* Image */}
                    <Grid2 size={empImagePreview ? 2 : 3}>
                        <Button variant="outlined" component="label" fullWidth sx={{ height: 40 }}>
                            Upload Emp Image
                            <input type="file" accept="image/png, image/jpeg, image/webp" hidden onChange={onImagePick} />
                        </Button>
                    </Grid2>
                    <Grid2 size={1} style={{ display: `${empImagePreview ? '' : 'none'}` }}>
                        {empImagePreview && (
                            <Box sx={{ border: '1px solid #eee', p: 1, borderRadius: 50, textAlign: 'center' }}>
                                <img src={empImagePreview} alt="preview" style={{ maxWidth: 30, maxHeight: 30, objectFit: 'contain' }} />
                            </Box>
                        )}
                    </Grid2>
                    <Grid2 size={3}>
                        <DateTimePicker
                            label='Join Date'
                            value={emp.joinDate ? dayjs(emp.joinDate) : joinDate}
                            onChange={handleJoinDateChange}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <DateTimePicker
                            label='Date of Birth'
                            value={emp.dateOfBirth ? dayjs(emp.dateOfBirth) : dateOfBirth}
                            onChange={handleDateofBirthChange}
                        />
                    </Grid2>
                    <Grid2 size={1.5}>
                        <TextField
                            variant='outlined'
                            label='Employee ID'
                            id='empID'
                            name='empID'
                            disabled
                            fullWidth
                            value={emp.empID}
                            size='small'
                        />
                    </Grid2>
                    <Grid2 size={1.5}>
                        <TextField
                            variant='outlined'
                            label='Mahcine ID'
                            id='machineID'
                            name='machineID'
                            fullWidth
                            value={emp.machineID}
                            onChange={handleChange}
                            size='small'
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <TextField
                            variant='outlined'
                            label='Employee Name'
                            id='empName'
                            name='empName'
                            fullWidth
                            placeholder='Muhammad Arasal'
                            size='small'
                            value={emp.empName}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <TextField
                            variant='outlined'
                            label='Father Name'
                            id='empFName'
                            name='empFName'
                            fullWidth
                            placeholder='Iqbal Ahmed'
                            size='small'
                            value={emp.empFName}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <TextField
                            variant='outlined'
                            label='C.N.I.C'
                            id='empCNIC'
                            name='empCNIC'
                            fullWidth
                            placeholder='12345-1234567-1'
                            size='small'
                            value={emp.empCNIC}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <TextField
                            variant='outlined'
                            label='Contact'
                            id='empContact'
                            name='empContact'
                            fullWidth
                            placeholder='0300-1234567'
                            size='small'
                            value={emp.empContact}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <TextField
                            variant='outlined'
                            label='Email'
                            id='empEmail'
                            name='empEmail'
                            fullWidth
                            placeholder='jamil@gmail.com'
                            size='small'
                            value={emp.empEmail}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <TextField
                            variant='outlined'
                            label='Emergency Contact Person'
                            id='empEmergencyCP'
                            name='empEmergencyCP'
                            fullWidth
                            placeholder={`Sibling's Name`}
                            size='small'
                            value={emp.empEmergencyCP}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <TextField
                            variant='outlined'
                            label='Emergency Person Contact'
                            id='empEmergencyCPC'
                            name='empEmergencyCPC'
                            fullWidth
                            placeholder={`Sibling's Contact No`}
                            size='small'
                            value={emp.empEmergencyCPC}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <AutoComplete
                            listData={departments}
                            columnName={'deptDesc'}
                            label={'Department'}
                            value={departments.find((c) => c.deptID === emp.deptDesc)}
                            // value={emp.deptDesc}
                            onChange={handleDeptChange}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <AutoComplete
                            listData={designations}
                            columnName={'desigID'}
                            label={'Designations'}
                            value={designations.find((c) => c.desigID === emp.desigID)}
                            // value={emp.deptDesc}
                            onChange={handleDeptChange}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <AutoComplete
                            listData={units}
                            columnName={'unitID'}
                            label={'Units'}
                            value={units.find((c) => c.unitID === emp.unitID)}
                            // value={emp.deptDesc}
                            onChange={handleDeptChange}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <AutoComplete
                            listData={shifts}
                            columnName={'shiftID'}
                            label={'Shifts'}
                            value={shifts.find((c) => c.shiftID === emp.shiftID)}
                            // value={emp.deptDesc}
                            onChange={handleDeptChange}
                        />
                    </Grid2>
                    <Grid2 size={1.5}>
                        <TextField
                            variant='outlined'
                            label='Salary'
                            id='empSalary'
                            name='empSalary'
                            fullWidth
                            placeholder='105000'
                            size='small'
                            value={emp.empSalary}
                            onChange={handleChange}
                            type='number'
                        />
                    </Grid2>
                    <Grid2 size={1.5}>
                        <CheckboxLabels
                            label={'Over Time'}
                            checked={emp.overTime}
                            onChange={(e) => { handleOTToggle(e.target.checked) }}
                        />
                    </Grid2>
                    <Grid2 size={1.5}>
                        <TextField
                            variant='outlined'
                            label='O.T. Rate'
                            id='empOTRate'
                            name='empOTRate'
                            fullWidth
                            placeholder='250'
                            size='small'
                            value={emp.empOTRate}
                            onChange={handleChange}
                            type='number'
                            disabled={!emp.overTime}
                        />
                    </Grid2>
                    <Grid2 size={1.5}>
                        <TextField
                            variant='outlined'
                            label='Probation Days'
                            id='empProbDays'
                            name='empProbDays'
                            fullWidth
                            placeholder='90'
                            size='small'
                            value={emp.empProbDays}
                            onChange={(e) => setProb(e.target.value)}
                            type='number'
                        />
                    </Grid2>
                    <Grid2 size={1.5}>
                        <TextField
                            variant='outlined'
                            label='Probation Ends'
                            id='empProbEnds'
                            name='empProbEnds'
                            fullWidth
                            size='small'
                            disabled
                            value={emp.empProbEnds ? dayjs(emp.empProbEnds).format('YYYY-MM-DD') : ''}
                        />
                    </Grid2>
                    <Grid2 size={1.5}>
                        <TextField
                            variant='outlined'
                            label='Salary After Prob'
                            id='empSalaryAfterProb'
                            name='empSalaryAfterProb'
                            fullWidth
                            size='small'
                            value={emp.empSalaryAfterProb}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={9}>
                        <TextField
                            variant='outlined'
                            label='Address'
                            id='empAddress'
                            name='empAddress'
                            fullWidth
                            placeholder='House No. L-123, Sector 11-B, North Karachi, Karachi.'
                            size='small'
                            value={emp.empAddress}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={1.5}>
                        <CheckboxLabels
                            label={'Fixed Salary'}
                            checked={emp.fixedSalary}
                            onChange={(e) => { handle_CreateUser_Toggle_FixedSalary(e.target.checked) }}
                        />
                    </Grid2>
                    <Grid2 size={1.5}>
                        <CheckboxLabels
                            label={'Create User'}
                            checked={emp.empUserStatus}
                            onChange={(e) => { handle_CreateUser_Toggle(e.target.checked) }}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <TextField
                            variant='outlined'
                            label='User Name'
                            id='empUserName'
                            name='empUserName'
                            fullWidth
                            size='small'
                            disabled={!emp.empUserStatus}
                            value={emp.empUserName}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <TextField
                            variant='outlined'
                            label='User Password'
                            id='empUserPassword'
                            name='empUserPassword'
                            fullWidth
                            size='small'
                            type="Password"
                            value={emp.empUserPassword}
                            onChange={handleChange}
                            disabled={!emp.empUserStatus}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <Button
                            variant='contained'
                            fullWidth
                            sx={{ color: 'white', fontSize: 16, fontWeight: 'bolder' }}
                            onClick={onSubmit}
                        >
                            SAVE EMPLOYEE
                        </Button>
                    </Grid2>
                    <Grid2 size={9}></Grid2>

                </Grid2>
                <Box sx={{ pointerEvents: `${emp.empID === '' ? 'none' : ''}`, opacity: `${emp.empID === '' ? 0.5 : 1}`, }}>
                    < Grid2 container spacing={2}>
                        {/* Allowances */}
                        <Grid2 size={4}>
                            <Typography sx={{ background: 'grey', mb: 1, p: 1, borderRadius: 5, color: 'white', fontSize: 20, fontWeight: 'bolder', textAlign: 'center', textShadow: 'black 2px 2px 5px' }}>
                                Allowances
                            </Typography>
                            {[...Array(10)].map((_, i) => (
                                <Divider key={i} variant="left" sx={{ bgcolor: i % 2 ? '#ffffff' : '#3f9cff' }} />
                            ))}
                        </Grid2>

                        <Grid2 size={8}></Grid2>

                        <Grid2 size={4}>
                            <AutoComplete
                                listData={allowances}
                                columnName={'Allowance'}
                                label={'Allowance'}
                                value={allowances.find((c) => c.allowanceID === allowancesData.allowanceID)}
                                onChange={handleDeptChange}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <TextField
                                variant='outlined'
                                label='Amount'
                                id='Amount'
                                name='rollNo'
                                fullWidth
                                placeholder={`091234`}
                                size='small'
                                value={allowancesData.Amount}
                                onChange={(e) => setAllowancesData(p => ({ ...p, Amount: e.target.value }))}
                            />
                        </Grid2>
                        <Grid2 size={2}>
                            <Button
                                variant='contained'
                                fullWidth
                                sx={{ color: 'white', fontSize: 16, fontWeight: 'bolder' }}
                                onClick={onSubmitAllowance}
                            >
                                ADD
                            </Button>
                        </Grid2>
                        <Grid2 size={12}>
                            {isLoadingEmpAll ?
                                <>
                                    <Loading />
                                </> :
                                <>
                                    <TableDataWithPagination
                                        tableColumns={allowancetableColumns}
                                        tableData={allRows && allRows}
                                        onEditClick={onAllowanceEditClick}
                                        onDeleteClick={onAllowanceDeleteClick}
                                    />

                                </>}

                        </Grid2>


                        {/* EDUCATION */}
                        <Grid2 size={4}>
                            <Typography sx={{ background: 'grey', mb: 1, p: 1, borderRadius: 5, color: 'white', fontSize: 20, fontWeight: 'bolder', textAlign: 'center', textShadow: 'black 2px 2px 5px' }}>
                                Employee Educational Information
                            </Typography>
                            {[...Array(10)].map((_, i) => (
                                <Divider key={i} variant="left" sx={{ bgcolor: i % 2 ? '#ffffff' : '#3f9cff' }} />
                            ))}
                        </Grid2>

                        <Grid2 size={8}></Grid2>

                        <Grid2 size={2}>
                            <AutoComplete
                                listData={Certifications}
                                columnName={'degree'}
                                label={'Degree'}
                                value={eduForm.degree}
                                onChange={handleDegreeChange}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <TextField
                                variant='outlined'
                                label='Institute'
                                id='eduUni'
                                name='institute'
                                fullWidth
                                placeholder={`Karachi University`}
                                size='small'
                                value={eduForm.institute}
                                onChange={(e) => setEduForm(p => ({ ...p, institute: e.target.value }))}
                            />
                        </Grid2>
                        <Grid2 size={1.5}>
                            <TextField
                                variant='outlined'
                                label='Passing Year'
                                id='eduYear'
                                name='year'
                                fullWidth
                                placeholder={`2016`}
                                size='small'
                                value={eduForm.year}
                                onChange={(e) => setEduForm(p => ({ ...p, year: e.target.value }))}
                            />
                        </Grid2>
                        <Grid2 size={2}>
                            <TextField
                                variant='outlined'
                                label='Grade'
                                id='eduGrade'
                                name='grade'
                                fullWidth
                                placeholder={`B / 3.0 GPA`}
                                size='small'
                                value={eduForm.grade}
                                onChange={(e) => setEduForm(p => ({ ...p, grade: e.target.value }))}
                            />
                        </Grid2>
                        <Grid2 size={2}>
                            <TextField
                                variant='outlined'
                                label='Roll No'
                                id='eduRollNo'
                                name='rollNo'
                                fullWidth
                                placeholder={`091234`}
                                size='small'
                                value={eduForm.rollNo}
                                onChange={(e) => setEduForm(p => ({ ...p, rollNo: e.target.value }))}
                            />
                        </Grid2>
                        <Grid2 size={1.5}>
                            <Button
                                variant='contained'
                                fullWidth
                                sx={{ color: 'white', fontSize: 16, fontWeight: 'bolder' }}
                                onClick={addEdu}
                            >
                                ADD
                            </Button>
                        </Grid2>
                        <Grid2 size={12}>
                            <TableDataWithPagination
                                tableColumns={tableColumns}
                                tableData={eduData}
                                onEditClick={onEditClick}
                            />
                        </Grid2>

                        {/* EXPERIENCE */}
                        <Grid2 size={4}>
                            <Typography sx={{ background: 'grey', mb: 1, p: 1, borderRadius: 5, color: 'white', fontSize: 20, fontWeight: 'bolder', textAlign: 'center', textShadow: 'black 2px 2px 5px' }}>
                                Employee Work Experience
                            </Typography>
                            {[...Array(10)].map((_, i) => (
                                <Divider key={i} variant="left" sx={{ bgcolor: i % 2 ? '#ffffff' : '#3f9cff' }} />
                            ))}
                        </Grid2>
                        <Grid2 size={8}></Grid2>

                        <Grid2 size={4}>
                            <TextField
                                variant='outlined'
                                label='Company Name'
                                id='expComp'
                                name='company'
                                fullWidth
                                placeholder={`Imperial Rags Private Limited`}
                                size='small'
                                value={expForm.company}
                                onChange={(e) => setExpForm(p => ({ ...p, company: e.target.value }))}
                            />
                        </Grid2>
                        <Grid2 size={2}>
                            <TextField
                                variant='outlined'
                                label='Designation'
                                id='expDesi'
                                name='designation'
                                fullWidth
                                placeholder={`I.T. Manager`}
                                size='small'
                                value={expForm.designation}
                                onChange={(e) => setExpForm(p => ({ ...p, designation: e.target.value }))}
                            />
                        </Grid2>
                        <Grid2 size={1.5}>
                            <AutoComplete
                                listData={years}
                                columnName={'year'}
                                label={'From'}
                                value={expForm.from}
                                onChange={handleYearFromChange}
                            />
                        </Grid2>
                        <Grid2 size={1.5}>
                            <AutoComplete
                                listData={years}
                                columnName={'year'}
                                label={'To'}
                                value={expForm.to}
                                onChange={handleYearToChange}
                            />
                        </Grid2>
                        <Grid2 size={1.5}>
                            <TextField
                                variant='outlined'
                                label='Last Pay'
                                id='expLastPay'
                                name='lastPay'
                                fullWidth
                                placeholder={`80,000`}
                                size='small'
                                value={expForm.lastPay}
                                onChange={(e) => setExpForm(p => ({ ...p, lastPay: e.target.value }))}
                            />
                        </Grid2>
                        <Grid2 size={1.5}>
                            <Button
                                variant='contained'
                                fullWidth
                                sx={{ color: 'white', fontSize: 16, fontWeight: 'bolder' }}
                                onClick={addExp}
                            >
                                ADD
                            </Button>
                        </Grid2>
                        <Grid2 size={12}>
                            <TableDataWithPagination
                                tableColumns={exptableColumns}
                                tableData={expData}
                                onEditClick={onEditClick}
                            />
                        </Grid2>
                    </Grid2>
                </Box>
            </Container >
            <Footer />
        </>
    )
}
